import React, { useEffect, useState } from "react";
import CountryFlag from "../components/CountryFlag/CountryFlag";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordAction } from "../redux/attemptSurvey/attemptSurvey.actions";
import { getCountryList } from "../redux/survey/survey.actions";
import {
  isExistPhoneNumberAction,
  RESET_IS_EXIST,
} from "../redux/auth/auth.actions";
import { toast } from "react-toastify";

export default function ForgetPassword() {
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    phone: "",
  });
  const [phoneCode, setPhoneCode] = useState("+39");
  const [currentLanguage, setCurrentLanguage] = useState("");
  const [isExistChecked, setIsExistChecked] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentLanguage(localStorage.getItem("language"));
  }, []);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^\d{10}$/.test(phone);

  const handleInputChange = (e, field) => {
    const value = e.target.value;

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (field === "email" && value) {
      setFormData((prev) => ({ ...prev, phone: "" }));
    } else if (field === "phone" && value) {
      setFormData((prev) => ({ ...prev, email: "" }));
      dispatch({ type: RESET_IS_EXIST });
    }
    setIsExistChecked(false);
    setIsSubmitted(false);
  };

  useEffect(() => {
    dispatch(getCountryList());
  }, [dispatch]);

  const { isExistPhoneNumber, isLoading, errorMsg } = useSelector(
    (state) => state.authInfo
  );

  // console.log("errorMsg", errorMsg);

  useEffect(() => {
    if (isSubmitted && isExistChecked) {
      // console.log("isExistPhoneNumber", isExistPhoneNumber);
      if (formData.phone) {
        if (!isExistPhoneNumber?.isExist && errorMsg?.isExist === false) {
          toast.error(
            currentLanguage === "Italian" 
              ? "Prova a usare l'email o un altro numero di telefono"
              : "Please try using email or another phone number"
          );
        } else if (isExistPhoneNumber?.isExist) {
          localStorage.setItem(
            "registerData",
            JSON.stringify({ phone: formData.phone, countryCode: phoneCode })
          );
          navigate("/auth/verify-mobile-otp", {
            state: {
              phone: formData.phone,
              countryCode: phoneCode,
              from: "/auth/forget-password",
            },
          });
        }
      }
    }
  }, [
    isSubmitted,
    formData.phone,
    phoneCode,
    currentLanguage,
    isExistPhoneNumber,
    errorMsg,
  ]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = { email: "", phone: "" };

    if (formData.email && !validateEmail(formData.email)) {
      newErrors.email =
        currentLanguage === "Italian"
          ? "Formato email non valido"
          : "Invalid email format";
    }

    if (formData.phone && !validatePhone(formData.phone)) {
      newErrors.phone =
        currentLanguage === "Italian"
          ? "Numero di telefono non valido"
          : "Invalid phone number";
    }

    if (!formData.email && !formData.phone) {
      newErrors.email =
        currentLanguage === "Italian"
          ? "Inserisci un'email o un numero di telefono valido"
          : "Enter a valid email or phone number";
      newErrors.phone =
        currentLanguage === "Italian"
          ? "Inserisci un'email o un numero di telefono valido"
          : "Enter a valid email or phone number";
    }

    setErrors(newErrors);

    if (!newErrors.email && !newErrors.phone) {
      if (formData.phone) {
        dispatch(isExistPhoneNumberAction(formData.phone));
        setIsExistChecked(true);
        setIsSubmitted(true);
      } else if (formData.email) {
        dispatch(
          resetPasswordAction({
            email: formData.email || undefined,
          })
        ).then(() => {
          navigate("/auth/reset-successfully");
        });
      }
    }
  };

  return (
    <div className="forget_pass_wrapper">
      <div className="top_text mb15">
        {currentLanguage === "Italian"
          ? "Inserisci il tuo numero di cellulare o email per reimpostare la password."
          : "Enter your mobile number or email id for reset password."}
      </div>
      <div className="verification_code">
        {currentLanguage === "Italian"
          ? "Ti invieremo un codice di verifica"
          : "We will send you verification code"}
      </div>
      <div className="input_wrapper">
        <input
          type="text"
          placeholder={
            currentLanguage === "Italian" ? "Indirizzo email" : "Email Id"
          }
          value={formData.email}
          onChange={(e) => handleInputChange(e, "email")}
        />
      </div>
      {errors.email && (
        <div
          className="error-text"
          style={{
            color: "red",
            fontSize: "12px",
            marginTop: "-10px",
            marginBottom: "10px",
          }}
        >
          {errors.email}
        </div>
      )}
      <div className="or">{currentLanguage === "Italian" ? "O" : "Or"}</div>

      <div className="input_wrapper mobile">
        <CountryFlag setPhoneCode={setPhoneCode} />
        <input
          type="text"
          placeholder={
            currentLanguage === "Italian"
              ? "Numero di cellulare"
              : "Mobile Number"
          }
          value={formData.phone}
          onChange={(e) => handleInputChange(e, "phone")}
          maxLength={10}
        />
      </div>
      {errors.phone && (
        <div
          className="error-text"
          style={{
            color: "red",
            fontSize: "12px",
            marginTop: "-10px",
            marginBottom: "10px",
          }}
        >
          {errors.phone}
        </div>
      )}
      <div className="action mb15">
        <button onClick={handleSubmit}>
          {currentLanguage === "Italian" ? "Invia" : "Send"}
        </button>
        <button className="cancel" onClick={() => navigate("/auth")}>
          {currentLanguage === "Italian" ? "Annulla" : "Cancel"}
        </button>
      </div>
    </div>
  );
}
